<template>
  <div>
    <div class="modal fade show d-block" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <i class="bi bi-funnel me-2"></i>
              Result Filter Configuration
            </h5>
            <button type="button" class="btn-close" @click="$emit('cancel')" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label class="form-label">Combination Method</label>
              <select v-model="localFilter.combinationMethod" class="form-select">
                <option value="AND">AND (all criteria must match)</option>
                <option value="OR">OR (any criteria may match)</option>
              </select>
            </div>
            <div>
              <label class="form-label">Criteria</label>
              <div v-for="(c, idx) in localFilter.criteria" :key="idx" class="card mb-2">
                <div class="card-body row g-2 align-items-center">
                  <div class="col-md-3">
                    <input v-model="c.object" type="text" class="form-control" placeholder="Object (e.g. location)">
                  </div>
                  <div class="col-md-3">
                    <input v-model="c.element" type="text" class="form-control" placeholder="Element (e.g. temp)">
                  </div>
                  <div class="col-md-2">
                    <select v-model="c.operator" class="form-select">
                      <option value="LESS_THAN">&lt;</option>
                      <option value="GREATER_THAN">&gt;</option>
                      <option value="EQUAL">=</option>
                    </select>
                  </div>
                  <div class="col-md-2">
                    <input v-model.number="c.value" type="number" class="form-control" placeholder="Value">
                  </div>
                  <div class="col-md-2">
                    <button type="button" class="btn btn-outline-danger btn-sm" @click="removeCriteria(idx)">
                      <i class="bi bi-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div>
                <button type="button" class="btn btn-outline-primary btn-sm mt-2" @click="addCriteria">
                    <i class="bi bi-plus-circle me-1"></i>
                    Add Criteria
                </button>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="$emit('cancel')">Cancel</button>
            <button type="button" class="btn btn-primary" @click="saveFilter">Save Filter</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
export default {
  name: 'ResultFilterEditor',
  props: {
    resultFilter: {
      type: Object,
      default: () => ({
        combinationMethod: 'AND',
        criteria: []
      })
    }
  },
  emits: ['save', 'cancel'],
  data() {
    return {
      localFilter: this.cloneFilter(this.resultFilter)
    };
  },
  methods: {
    cloneFilter(filter) {
      // Deep clone to avoid mutating parent
      return {
        combinationMethod: filter.combinationMethod || 'AND',
        criteria: (filter.criteria || []).map(c => ({
          object: c.object || '',
          element: c.element || '',
          value: c.value || 0,
          operator: c.operator || 'EQUAL'
        }))
      };
    },
    addCriteria() {
      this.localFilter.criteria.push({
        object: '',
        element: '',
        value: 0,
        operator: 'EQUAL'
      });
    },
    removeCriteria(idx) {
      this.localFilter.criteria.splice(idx, 1);
    },
    saveFilter() {
      // Emit a deep copy to avoid parent mutation
      this.$emit('save', JSON.parse(JSON.stringify(this.localFilter)));
    }
  }
};
</script>

<style scoped>
.card {
  background: var(--bs-light);
}
</style>